
<style lang="scss">
.announce-update {
    .announce-form {
        .ivu-date-picker .ivu-select-dropdown {
            z-index: 100000;
        }
    }
    .preview-title {
        text-align: center;
        font-weight: bold;
        font-size: 16px;
    }
    .preview-modal {
        min-height: 200px;
        margin: 15px;
        // border: 1px solid #ccc;
        border-radius: 5px;
        padding: 5px;
    }
    .preview-date {
        font-weight: bold;
        text-align: right;
        margin: 15px;
    }
}
</style>
<template>
    <div class="clearfix announce-update">
        <compWrapper title="系统公告基本信息" theme="primary">
            <vForm
                class="clearfix announce-form margin-top-15 padding-right-15"
                ref="dataForm"
                v-model="formData"
                :labelWidth="100"
            >
                <vCol span="12" style="height: 52px;">
                    <vFormItem label="公告标题" prop="title" :rules="required">
                        <vInput v-model="formData.title"></vInput>
                    </vFormItem>
                </vCol>
                <vCol v-if="orgRoleLabel === 'service'" span="12" style="height: 52px;">
                    <vFormItem label="通知模式" prop="notifyType" :rules="required">
                        <vSelect v-model="formData.notifyType">
                            <vOption
                                v-for="item in this.getNotifyType"
                                :key="item.key"
                                :value="item.value"
                            >{{item.label}}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol v-if="userIsSuper" style="height: 52px;" span="12">
                    <vFormItem label="是否全局公告" prop="isGlobal">
                        <Checkbox :true-value="1" :false-value="0" v-model="formData.isGlobal"></Checkbox>
                    </vFormItem>
                </vCol>
                <!-- 展示本地时间，提交utc时间 -->
                <vCol span="12" style="height: 52px;">
                    <vFormItem label="过期时间" prop="expiresAt">
                        <DatePicker
                            style="width: 100%;"
                            v-model="formData.expiresAt"
                            type="datetime"
                        ></DatePicker>
                    </vFormItem>
                </vCol>
                <!-- <vCol span="12">
                    <vFormItem label="公告多语言标识" prop="langKey">
                        <vInput v-model="formData.langKey"></vInput>
                    </vFormItem>
                </vCol>-->
                <!-- <vCol span="12">
                    <vFormItem label="公告格式" prop="format">
                        <vSelect v-if="params.type === 'add'" v-model="formData.format">
                            <vOption
                                v-for="item in getFormat"
                                :key="item.key"
                                :value="item.value"
                            >{{item.label}}</vOption>
                        </vSelect>
                        <div v-else style="font-weight: 800;">{{getFormatLabel(formData.format)}}</div>
                    </vFormItem>
                </vCol>-->
                <!-- <vCol span="12">
                    <vFormItem label="公告Url" prop="url">
                        <vInput v-model="formData.url"></vInput>
                    </vFormItem>
                </vCol>-->
                <!-- <vCol span="12">
                    <vFormItem label="优先级" prop="priority">
                        <vInputNumber v-model="formData.priority"></vInputNumber>
                    </vFormItem>
                </vCol>-->
                <vCol span="24">
                    <vFormItem label="公告描述" prop="brief">
                        <vTextarea v-model="formData.brief"></vTextarea>
                    </vFormItem>
                </vCol>
                <vCol span="24">
                    <vFormItem label="公告内容" prop="brief">
                        <div class="announce-content" ref="announceContent"></div>
                    </vFormItem>
                </vCol>
                <vCol span="24">
                    <vFormItem label="附件">
                        <!-- <Button type="primary" @click="uploadFile">上传</Button> -->
                        <compMutiUpload
                            style="display: inline-block;"
                            v-bind="easyFileProps"
                            @on-success="easySuccess"
                            @on-cancel="cancelUpload"
                        ></compMutiUpload>
                        <Button class="margin-left-15" type="error" @click="clearUpload">清空</Button>
                        <div style="margin: 15px 0;">
                            <Table :stripe="true" :columns="attachColumns" :data="attachList"></Table>
                        </div>
                    </vFormItem>
                </vCol>
            </vForm>
        </compWrapper>
        <!-- <vModal
			class="hidefooter customerupload"
			v-model="operate.show"
			:title="operate.title"
			v-bind="operate"
		>
			<compMutiUpload
                v-bind="getFileProps"
				@on-success="aaasuccess"
				@on-cancel="cancelUpload"
			>
            <div slot="content" class="color-error">测试插槽</div>
            <div style="display: inline-block;" slot="footer">
                <Button type="primary">下载模板</Button>
            </div>
			</compMutiUpload>
			<footer slot="footer" v-show="false"></footer>
        </vModal>-->
        <vModal
            class="hidefooter customerupload"
            v-model="previewOperate.show"
            :title="previewOperate.title"
            v-bind="previewOperate"
        >
            <div class="preview-title">{{formData.title}}</div>
            <div class="preview-modal" v-html="previewOperate.html"></div>
            <div class="preview-date">{{getDate()}}</div>
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <footer class="pull-right text-right width-100per">
            <Button type="success" class="margin-right-15" @click="preview">预览</Button>
            <Button type="primary" class="margin-right-15" @click="submit">确认</Button>
            <Button @click="cancel">取消</Button>
        </footer>
        <vLoading loading size="large" fix v-if="loading"></vLoading>
    </div>
</template>

<script>
import E from "wangeditor";
import HttpService from "../../service/baseHttp";
import * as moment from "moment";
import "moment-timezone";
import {
    HttpUpdateUcAnnouncement,
    HttpLoadUcAnnouncement,
    HttpDelAttachmentFile,
    HttpDelUcAnnouncementRelAttach,
} from "@/service/ucadm";
import { mapGetters, mapState } from "vuex";
import mixinList from "./mixin";
export default {
    mixins: [mixinList],
    props: ["params"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormEdit: () => import("@components/templates/formedit"),
    },
    data() {
        return {
            formData: {
                title: "",
                // 默认仅当前
                notifyType: 2,
                priority: 0,
                format: 3,
                isGlobal: 1,
                langKey: "",
                // 过期时间默认为当前UTC时间+48小时
                expiresAt: moment()
                    .utc()
                    .add(48, "h")
                    .format("YYYY-MM-DD HH:mm:ss"),
            },
            editor: null,
            attachList: [],
            required: [
                {
                    required: true,
                    message: "该信息不能为空,请填写",
                },
            ],
            orgRoleLabel: null,
            userIsSuper: false,
            loading: false,
            // operate: {
            // 	id: null,
            // 	title: "",
            //     show: false,
            //     actionurl:'',
            //     boxtype:'',
            //     downexcel:'',
            // 	component: null
            // },
            previewOperate: {
                title: "预览",
                show: false,
                width: 800,
            },
        };
    },
    created() {
        this.orgRoleLabel = this.organization.roleLabel;
        // 用户是否超管
        this.userIsSuper = this.isSuper;
    },
    mounted() {
        this.getItemDetail();
        // 创建编辑器
        if (!this.$refs.announceContent) {
            let timer = setInterval(() => {
                if (this.$refs.announceContent) {
                    this.editor = new E(this.$refs.announceContent);
                    // 关闭样式过滤，可以复制带样式的文本
                    this.editor.customConfig.pasteFilterStyle = false;
                    // // 粘贴的内容
                    // this.editor.customConfig.pasteTextHandle = (content) => {
                    //     console.log(content);
                    //     // 匹配图片
                    //     let reg = /<img[\s\S]*?>/g;
                    //     // let result = reg.exec(content)
                    //     let resultArr = content.match(reg);
                    //     if (!resultArr) return content;
                    //     console.log("文字匹配结果", resultArr);
                    //     let srcArr = resultArr.map((item) => {
                    //         return item
                    //             .replace(/<img[\s\S]*?src="/, "")
                    //             .replace(/"[\s\S]*?>/, "");
                    //     });
                    //     console.log("路径", srcArr);
                    //     // 网络图片转blob
                    //     let files = []
                    //     try {
                    //         let that = this
                    //         let fs = new FileReader()
                    //         srcArr.map((item) => {
                    //             let ext = item.replace(item.match(/[\s\S]*\./)[0], '')
                    //             let xhr = new XMLHttpRequest();
                    //             // xhr.responeseType = "blob";
                    //             xhr.open("get", item + '?' + new Date().getTime(), true);
                    //             xhr.onload = function () {
                    //                 if (this.status == 200) {
                    //                     let imgData = this.response;
                    //                     console.log(this.response)
                    //                     let blob = new Blob([imgData]);
                    //                     // let file = ((blob) => {
                    //                     //     return new File([blob], `netImg${moment().format(
                    //                     //         "YYYYMMDDHHmmss"
                    //                     //     )}.${ext}`)
                    //                     // })(blob);
                    //                     // console.log(file)
                    //                     console.log(blob)
                    //                     let img = new Image()
                    //                     img.src = URL.createObjectURL(blob)
                    //                     console.log(img)
                    //                     that.uploadImg([img], (url) => {
                    //                         console.log(url)
                    //                         content = content
                    //                     })
                    //                 }
                    //             };
                    //             xhr.send();
                    //         });
                    //     } catch (err) {
                    //         console.log(err);
                    //     }
                    //     return content;
                    // };
                    // 上传图片的方法
                    this.editor.customConfig.customUploadImg = (
                        files,
                        insert
                    ) => {
                        this.uploadImg(files, insert);
                    };
                    this.editor.create();

                    this.$refs.announceContent.addEventListener(
                        "paste",
                        (e) => {}
                    );
                    clearInterval(timer);
                }
            }, 100);
        }
    },
    computed: {
        ...mapState(["organization"]),
        ...mapGetters(["isSuper", "getAuthUser"]),
        attachColumns() {
            let that = this;
            return [
                {
                    title: "附件名称",
                    key: "attachTitle",
                },
                {
                    title: "操作",
                    width: 120,
                    render(h, { row, index }) {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            that.deleteAttachOne(index, true);
                                        },
                                    },
                                },
                                "删除"
                            ),
                        ]);
                    },
                },
            ];
        },
        // getFileProps(){
        //     return {
        //         data: {
        //             srcLabel: this.id || 0,
        //             model: 'org',
        //             type: 'announce'
        //         },
        // 		action: process.env.VUE_APP_APIURL_UC + this.operate.actionurl,
        //         name: "multipartFile",
        //         multiple: true
        //     }
        // },
        easyFileProps() {
            return {
                data: {
                    srcLabel: this.id || 0,
                    model: "org",
                    type: "announce",
                },
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: true,
                type: 0,
                easyMode: {
                    text: "上传",
                    type: "primary",
                    style: "margin-left: 15px;",
                },
            };
        },
    },
    methods: {
        getDate() {
            return moment(moment().format("YYYY-MM-DD HH:mm:ss"))
                .utc()
                .format("YYYY-MM-DD HH:mm:ss");
        },
        preview() {
            this.previewOperate.show = true;
            this.previewOperate.html = this.editor.txt.html();
        },
        getImgArr(text) {
            // console.log(content)
            let reg = new RegExp(/file:\/\/.*\.(jpeg|png|jpg)/, "g");
            let resultArr = [];
            let resultItem;

            while (reg.exec(text) !== null) {
                resultItem = reg.exec(text);
                resultArr.push(resultItem);
            }
            return resultItem;
        },
        uploadImg(files, insert) {
            // files 是 input 中选中的文件列表
            // 用原来的构造数据方式
            let formData = new FormData();
            let nowDate = new Date();
            Object.entries({
                srcLabel: `content${nowDate.getFullYear()}${
                    nowDate.getMonth() + 1
                }${nowDate.getDate()}`,
                model: "org",
                type: "announce",
            }).forEach(([key, val]) => {
                formData.append(key, val);
            });
            formData.append("multipartFile", files[0]);
            formData.append("contextId", global.SYSID);
            let that = this;
            const args = [
                `${process.env.VUE_APP_APIURL_UC}/api/v1/BizAttach/uploadFile`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + global.AUTH_TOKEN,
                    },
                    withCredentials: true,
                    transformRequest(data) {
                        return data;
                    },
                },
            ];
            // 发起请求
            const ajaxRequest = HttpService.post(...args).then((res) => {
                // insert 是获取图片 url 后，插入到编辑器的方法
                // 上传代码返回结果之后，将图片插入到编辑器中
                insert(res.data.genUrl);
            });
        },
        // uploadFile () {
        //     this.operate = {
        // 		show: true,
        //         title: '添加附件',
        //         actionurl:'/api/v1/BizAttach/uploadFile',
        //         boxtype:'document',
        //         downexcel:'',
        // 	};
        // },
        // aaasuccess (res) {
        //     res.items.map(item => {
        //         this.attachList.push(item)
        //     })
        //     this.cancelUpload()
        // },
        easySuccess(res) {
            let data = res.data;
            this.attachList.push({
                attachId: data.entity.id,
                attachOpAt: data.entity.createdAt,
                attachTitle: data.entity.title,
                attachBrief: data.entity.brief,
                attachUrl: data.genUrl,
            });
        },
        cancelUpload() {
            this.operate.show = false;
        },
        deleteAttachOne(index, needSplice) {
            if (this.params.type === "edit") {
                // 编辑时兼容attachId为null的附件，老公告数据中附件id为null
                if (this.attachList[index].attachId === null)
                    return this.attachList.splice(index, 1);
                HttpDelUcAnnouncementRelAttach({
                    id: this.formData.id,
                    attachId: this.attachList[index].attachId,
                }).then(
                    (res) => {
                        if (needSplice) this.attachList.splice(index, 1);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            } else {
                HttpDelAttachmentFile({
                    id: this.attachList[index].attachId,
                }).then(
                    (res) => {
                        if (needSplice) this.attachList.splice(index, 1);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
        },
        dataURItoBlob: function (dataURI) {
            // convert base64 to raw binary data held in a string

            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            let byteString;
            if (dataURI.split(",")[0].indexOf("base64") >= 0) {
                byteString = atob(dataURI.split(",")[1]);
            } else {
                byteString = unescape(dataURI.split(",")[1]);
            }

            // separate out the mime component

            let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

            // write the bytes of the string to an ArrayBuffer

            let ab = new ArrayBuffer(byteString.length);

            // create a view into the buffer

            let ia = new Uint8Array(ab);

            // set the bytes of the buffer to the correct values

            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            // write the ArrayBuffer to a blob, and you're done

            let blob = new Blob([ab], { type: mimeString });
            return blob;
        },
        dataURItoFile: function (dataURI, filename, lastModified) {
            // convert base64 to raw binary data held in a string

            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            let byteString;
            if (dataURI.split(",")[0].indexOf("base64") >= 0) {
                byteString = atob(dataURI.split(",")[1]);
            } else {
                byteString = unescape(dataURI.split(",")[1]);
            }

            // separate out the mime component

            let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
            if (!lastModified) {
                lastModified = Date.now();
            }
            if (!filename) {
                let ext = mimeString.split("/")[1] || "bin";
                filename = `upload.${ext}`;
            }
            // write the bytes of the string to an ArrayBuffer

            let ab = new ArrayBuffer(byteString.length);

            // create a view into the buffer

            let ia = new Uint8Array(ab);

            // set the bytes of the buffer to the correct values

            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            // write the ArrayBuffer to a blob, and you're done

            let file = new File([ab], filename, {
                type: mimeString,
                lastModified: lastModified,
            });
            return file;
        },
        postUploadDataUri(dataURI, addonData, filename, field) {
            let dataFile = this.dataURItoFile(dataURI, filename);
            let postData = new FormData();
            if (!field) {
                field = "upload_file";
            }
            postData.append(field, dataFile, dataFile.name);
            if (addonData) {
                Object.keys(addonData).forEach(function (key) {
                    postData.append(key, addonData[key]);
                });
            }
            const _this = this;
            this.$axios
                .post(this.uploadUrl, postData, {
                    "content-type": "multipart/form-data",
                })
                .then(function (response) {
                    //handle succeed
                    let resp = response.data;
                    // console.log(resp);
                    dataFile.response = resp;
                    _this.uploadList.push(dataFile);
                    _this.handlePreview(resp.data.gen_url);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        handleBeforeUpload(file) {
            if (!this.handleCheckListSize()) {
                return false;
            }
            // 创建一个 FileReader 对象
            let reader = new FileReader();
            // readAsDataURL 方法用于读取指定 Blob 或 File 的内容
            // 当读操作完成，readyState 变为 DONE，loadend 被触发，此时 result 属性包含数据：URL（以 base64 编码的字符串表示文件的数据）
            // 读取文件作为 URL 可访问地址
            reader.readAsDataURL(file);

            const _this = this;
            // eslint-disable-next-line no-unused-vars
            reader.onloadend = function (e) {
                _this.handlePreview(reader.result);
                _this.$refs.upload.post(
                    _this.dataURItoFile(
                        reader.result,
                        file.name,
                        file.lastModified
                    )
                );
                // _this.postUploadDataUri(reader.result, _this.formData)
                // file.url = reader.result;
                // _this.uploadList.push(file);
            };
            return false;
        },
        clearUpload() {
            this.attachList.map((item, index) => {
                this.deleteAttachOne(index);
            });
            this.attachList = [];
        },
        getFormatLabel(value) {
            return this.getFormat.filter((item) => {
                return item.value === value;
            })[0].label;
        },
        cancel() {
            this.$emit("on-close");
        },
        async submit() {
            let vaild = await this.$refs.dataForm.validate();
            if (!vaild) return;
            this.formData.expiresAt = moment(this.formData.expiresAt).format(
                "YYYY-MM-DD HH:mm:ss"
            );
            let meta = null;
            if (this.attachList.length > 0) {
                meta = {
                    items: this.attachList,
                    opAt: this.attachList[0].attachOpAt,
                    organizationId: global.SYSID,
                };
            }
            this.formData.content = this.editor.txt.html();
            this.loading = true;
            let formData = {
                ...this.formData,
                meta: JSON.stringify(meta),
            };
            if (this.params.type === "edit") {
                formData.id = this.params.id;
            }
            let response = await HttpUpdateUcAnnouncement({
                ...formData,
            }).catch((err) => {
                this.$VMessage.error(err.message);
            });
            if (response) {
                this.$VMessage.success(response.message);
                this.$emit("on-close");
                this.$emit("on-update");
            }
            this.loading = false;
        },
        async getItemDetail() {
            if (this.params.type !== "edit") return;
            this.loading = true;
            const response = await HttpLoadUcAnnouncement({
                id: this.params.id,
            }).catch((err) => {
                this.$VMessage.error(err.message);
            });
            if (response) {
                const { title, brief } = response.data.entity || {};
                const isGlobal = response.data.isGlobal ? 1 : 0;
                // this.formData = { displayName, name, description, isGlobal };
                // this.checkIds = this.permissionIds = response.data.permissionIds || [];
                this.formData = {
                    isGlobal: isGlobal,
                    ...response.data.entity,
                };
                this.attachList = response.data.entity.meta
                    ? JSON.parse(response.data.entity.meta).items
                    : [];
                let timer = setInterval(() => {
                    if (this.editor) {
                        // this.editor.txt.html(this.formData.content)
                        this.editor.cmd.do("insertHTML", this.formData.content);
                        clearInterval(timer);
                    }
                }, 100);
            }
            this.loading = false;
        },
    },
};
</script>
